var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSentservice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#2D53DA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 17.8332V16.0832H12.2917L14.3333 13.1665V14.9165H15.7917L13.75 17.8332V17.8332M9.375 16.6665V16.6665V16.6665V16.6665V16.6665V16.6665V16.6665V16.6665V16.6665V16.6665M8.79167 17.8332C8.62639 17.8332 8.48785 17.7773 8.37604 17.6655C8.26424 17.5537 8.20834 17.4151 8.20834 17.2498V7.9165C8.20834 7.75123 8.26424 7.61268 8.37604 7.50088C8.48785 7.38907 8.62639 7.33317 8.79167 7.33317H9.95834V6.1665H12.2917V7.33317H13.4583C13.6236 7.33317 13.7622 7.38907 13.874 7.50088C13.9858 7.61268 14.0417 7.75123 14.0417 7.9165V11.9998C13.8375 11.9998 13.6382 12.0169 13.4438 12.0509C13.2493 12.0849 13.0597 12.1359 12.875 12.204V8.49984H9.375V16.6665H10.7458C10.8236 16.8901 10.9184 17.0991 11.0302 17.2936C11.142 17.488 11.2757 17.6679 11.4313 17.8332H8.79167V17.8332",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentservice);
export default __webpack_public_path__ + "static/media/sentservice.e8747d658dc866c7ae8ab40916c5b44f.svg";
export { ForwardRef as ReactComponent };